import { z } from 'zod';
import { idSchema, isoTimestampSchema } from './primitives.js';
/**
 * How far one member of a channel has got through it.
 *
 * Two cursors, each the `createdAt` of the newest message they cover:
 *   - `deliveredUpTo` - this member's client has received everything up to here
 *   - `readUpTo`      - this member has had the conversation open up to here
 *
 * Cursors only ever move forwards, and reading implies delivery, so
 * `readUpTo <= deliveredUpTo` whenever both are set. A sender works out the state
 * of their own message by comparing its `createdAt` with the other members'
 * cursors: no cursor past it is "sent", a delivered one is "delivered", a read
 * one is "seen".
 *
 * `null` means "not yet" - nothing has been delivered or read in this channel.
 */
export const channelReceiptSchema = z.object({
    userId: idSchema,
    deliveredUpTo: isoTimestampSchema.nullable(),
    readUpTo: isoTimestampSchema.nullable(),
});
/** Which cursor an acknowledgement advances. */
export const receiptKindSchema = z.enum(['delivered', 'read']);
//# sourceMappingURL=receipt.js.map